// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jgsY","top":"styles_top__QlKCv"};